import { Controller } from 'stimulus';

// Keeps the "Default Value" dropdown in sync with the comma-separated
// Dropdown Options text field so a default can be picked before the
// parameter is persisted. Old Stimulus 1.x target syntax (data-target).
export default class extends Controller {
  static targets = ['source', 'select'];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasSelectTarget || !this.hasSourceTarget) return;

    const current = this.selectTarget.value;
    const options = (this.sourceTarget.value || '')
      .split(',')
      .map((option) => option.trim())
      .filter((option) => option.length > 0);

    this.selectTarget.innerHTML = '';

    const blank = document.createElement('option');
    blank.value = '';
    blank.textContent = 'No default';
    this.selectTarget.appendChild(blank);

    options.forEach((option) => {
      const el = document.createElement('option');
      el.value = option;
      el.textContent = option;
      if (option === current) el.selected = true;
      this.selectTarget.appendChild(el);
    });
  }
}
